import { render, staticRenderFns } from "./Cat.vue?vue&type=template&id=ec37fa32&"
import script from "./Cat.vue?vue&type=script&lang=js&"
export * from "./Cat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports